import React, {useRef, useState} from 'react';
import { useNavigate} from 'react-router-dom';
import {Input, Button, message, Watermark, Row, Col} from "antd";
import axios from 'axios';
import Logo from "../../assets/pictures/truck.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from 'react-router-dom';
import {useWindowDimensions} from "../../contexts/WindowDimensionsContext";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const PasswordReset = ({ backendApiUrl }) => {
    const query = useQuery();
    const token = query.get("token");
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [status, setStatus] = useState({ newPassword: '', confirmPassword: '' });
    const windowDimensions = useWindowDimensions()
    const formRef = useRef(null);

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        if (name === 'newPassword') setNewPassword(value);
        else if (name === 'confirmPassword') setConfirmPassword(value);

        setStatus((prev) => ({
            ...prev,
            [name]: value.length >= 4 ? 'success' : 'error'
        }));
    };

    const validatePasswords = () => {
        if (newPassword !== confirmPassword) {
            message.error("Les mots de passe ne correspondent pas.");
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        if (!validatePasswords()) return;

        try {
            const response = await axios.post(`${backendApiUrl}/user/reset-password/${token}`, {
                newPassword
            }, {
                headers: { "Content-Type": "application/json" }
            });

            if (response.data.success) {
                message.success("Mot de passe réinitialisé avec succès !");
                navigate("/login");
            } else {
                message.error(response.data.error || "Le lien de réinitialisation est invalide ou expiré.");
            }
        } catch (error) {
            console.error(error);
            message.error("Une erreur est survenue. Veuillez réessayer.");
        }
    };

    return (
        <Watermark zIndex={-1} content="Team Kimmel">
            <div style={{ height: windowDimensions.windowHeight }} className={"overflow-auto"}>
                <div className={"overflow-auto"}>
                    <Row className={`justify-content-center align-items-center mx-2 overflow-auto`} style={{
                        minHeight: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <Col
                            className={windowDimensions.wWCheck(700) ? "mb-32" : ""}
                            style={{
                                background: "var(--White)",
                                padding: windowDimensions.wWCheck(700) ? "35px" : "20px",
                                borderRadius: "15px",
                                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                                minWidth: windowDimensions.wWCheck(700) ? "500px" : "400px",
                                width: "100%",
                                overflowY: "auto"
                            }}
                            xs={12} sm={7} md={6} lg={4} xl={3}
                        >
                            <div className="text-center mb-6">
                                <h1 className="text-1500 text-3xl">Parc Gest Team Kimmel</h1>
                            </div>
                            <div className="d-flex align-items-center justify-content-center mb-6">
                                <img src={Logo} alt="Team Kimmel" className="reset-password-logo" style={{filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.3))", borderRadius: "10px", maxWidth: windowDimensions.wWCheck(700) ? '350px' : "250px" }}/>
                            </div>
                            <h3 className="text-1500 text-2xl text-custom-blue text-center">Réinitialiser le mot de passe</h3>
                            <p className="text-700 mt-0.5 text-center">Veuillez entrer votre nouveau mot de passe</p>

                            <form ref={formRef}>
                                <div className="form-group mt-6">
                                    <label htmlFor="newPassword">Nouveau mot de passe</label>
                                    <Input.Password
                                        id="newPassword"
                                        name="newPassword"
                                        placeholder="Nouveau mot de passe"
                                        value={newPassword}
                                        onChange={handlePasswordChange}
                                        status={status.newPassword}
                                        prefix={<FontAwesomeIcon icon={faKey} />}
                                        className="reset-input"
                                        style={{fontSize: windowDimensions.wWCheck(500) ? "" : "16px"}}
                                    />
                                </div>

                                <div className="form-group mt-3">
                                    <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                                    <Input.Password
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        placeholder="Confirmer le mot de passe"
                                        value={confirmPassword}
                                        onChange={handlePasswordChange}
                                        status={status.confirmPassword}
                                        prefix={<FontAwesomeIcon icon={faKey} />}
                                        className="reset-input"
                                        style={{fontSize: windowDimensions.wWCheck(500) ? "" : "16px"}}
                                    />
                                </div>

                                <Button
                                    type="primary"
                                    className="w-100 mt-6"
                                    onClick={handleSubmit}
                                    disabled={!newPassword || !confirmPassword || status.newPassword === 'error' || status.confirmPassword === 'error'}
                                >
                                    Réinitialiser le mot de passe
                                </Button>
                            </form>
                        </Col>
                    </Row>
                </div>
            </div>
        </Watermark>
    );
};

export default PasswordReset;
